import { useTheme } from '@mui/material';
import type { BowlingSummaryDay } from '@strength/domain-workout';
import { SOURCE_DOT_DIAMETER_PX } from './slots/common';

export type DayCornerIndicatorProps = {
  crossBlock: BowlingSummaryDay;
};

/**
 * Small filled purple circle rendered at the top-right corner of a day-
 * header cell when the day has a cross-block bowling annotation. Purely
 * visual — the provenance popover shown on the day header (the same one
 * non-overlay days use) carries the details, including the "Team Entered"
 * line for cross-team sources.
 */
export const DayCornerIndicator = ({ crossBlock }: DayCornerIndicatorProps) => {
  const { palette } = useTheme();

  if (crossBlock.kind === 'current') return null;

  const diameter = SOURCE_DOT_DIAMETER_PX;

  return (
    <span
      aria-hidden
      style={{
        position: 'absolute',
        top: 2,
        right: 2,
        display: 'inline-flex',
        lineHeight: 0,
      }}
    >
      <svg
        width={diameter}
        height={diameter}
        viewBox={`0 0 ${diameter} ${diameter}`}
        aria-hidden="true"
        focusable="false"
      >
        <circle
          cx={diameter / 2}
          cy={diameter / 2}
          r={diameter / 2}
          fill={palette.accents.violet[400]}
        />
      </svg>
    </span>
  );
};
